// Store
import store from '../store/store';

// Utils
import { getCurrentFieldSelectedLabel, getRegionNameFormatted } from '../utils/popup.utils';

// Configs
import {
  ADMIN__5X5km,
  ADMIN__Admin1,
  ADMIN__Admin2,
  DATA_VALUE_PRECISION,
  DHSREGEN,
  NO_VALUE,
  NO_VALUE_LABEL,
  SIDEBAR_MAP_FILTER_FIELDS,
} from './map.configs';
import { SidebarMapFilterFieldsType } from './types';

export const defaultPopupOptions = {
  collapseEnabled: false,
};
export const POPUP_INDICATOR_LABEL_CLASS = 'popup-indicator-label';
export const POPUP_REGION_NAME_CLASS = 'popup-region-name';
export const POPUP_VALUE_CLASS = 'popup-value';
export const EXP_INFO_ROUNDED_VALUE_NAME = 'roundedValue';
export const POPUP_MARKER_COLOR = '#0961a7';
export const POPUP_MARKER_WIDTH = 10;

const adminLevelRegionNameDict: { [key: string]: string } = {
  [ADMIN__Admin1]: DHSREGEN,
  [ADMIN__Admin2]: 'ADM2_NAME',
};

const adminLevelNumberDict: { [key: string]: string } = {
  [ADMIN__Admin1]: 'L1',
  [ADMIN__Admin2]: 'L2',
  [ADMIN__5X5km]: ADMIN__5X5km,
};

const createPopupTemplateContent = () => {
  const selectedIndicatorLabel = store.getState().admin2EstimatesSlice.indicatorSelected?.label;
  const adminSelected = store.getState().sidebarMapFiltersSlice.adminSelected;
  const selectedAdminName = adminLevelRegionNameDict[adminSelected];
  const selectedAdminLevel = adminLevelNumberDict[adminSelected];

  return `
  <p class="${POPUP_INDICATOR_LABEL_CLASS}">${selectedIndicatorLabel}</p>
  <p class="${POPUP_REGION_NAME_CLASS}">{${selectedAdminName}} (${selectedAdminLevel})</p>
  <p class="${POPUP_VALUE_CLASS}">{expression/${EXP_INFO_ROUNDED_VALUE_NAME}}</p>
`;
};

const createPopupTemplateTitle = () => {
  const title = store.getState().admin2EstimatesSlice.surveySelected?.value;
  return title;
};

export const createRoundedValueExpInfo = () => {
  const { fieldSelected } = store.getState().sidebarMapFiltersSlice;
  const attributeField = `$feature.${fieldSelected}`;

  return {
    name: EXP_INFO_ROUNDED_VALUE_NAME,
    expression: `IIf( ${attributeField} == ${NO_VALUE}, "${NO_VALUE_LABEL}", "${getCurrentFieldSelectedLabel()}: " + Round(${attributeField}, ${DATA_VALUE_PRECISION}))`,
  };
};

export const createPopupTemplate = (): any => {
  const popupTemplate = {
    title: createPopupTemplateTitle,
    content: createPopupTemplateContent,
    expressionInfos: [createRoundedValueExpInfo()],
  };
  return popupTemplate;
};

/**
 * Create the content for the admin 2 popup template
 * @param {Object} props - The graphic properties
 * @returns {string} - The content for the admin 2 popup template
 */
const createAdmin2PopupTemplateContent = (props: any) => {
  const { attributes } = props.graphic;
  const { indicatorSelected } = store.getState().admin2EstimatesSlice;

  const selectedIndicatorLabel = indicatorSelected?.label;
  const currentFieldSelectedLabel = getCurrentFieldSelectedLabel();

  const dataValues = SIDEBAR_MAP_FILTER_FIELDS.map((item: SidebarMapFilterFieldsType) => {
    const labelClass = currentFieldSelectedLabel === item.label ? 'strong' : '';
    const valueFormatted = item.format(attributes[item.value]);

    return `<p class='${POPUP_VALUE_CLASS}'><span class='${labelClass}'>${item.label}</span>: ${valueFormatted}</p>`;
  });

  const admin1Name: string = attributes?.ADM1_NAME;
  const admin2Name: string = attributes?.ADM2_NAME;
  const regionNameFormatted = getRegionNameFormatted(admin1Name, admin2Name);

  return (
    `<p class='${POPUP_INDICATOR_LABEL_CLASS}'>${selectedIndicatorLabel}</p>` +
    `<p class='${POPUP_REGION_NAME_CLASS}'>${regionNameFormatted}</p>` +
    `<div class='popup-content__admin2'>${dataValues.join('')}</div>`
  );
};

/**
 * Create the template for the admin 2 popup
 * @returns {Object} - The popup template for the admin 2 layer
 */
export const createAdmin2PopupTemplate = (): any => {
  const popupTemplate = {
    title: createPopupTemplateTitle,
    content: createAdmin2PopupTemplateContent,
    outFields: ['*'],
  };

  return popupTemplate;
};
